import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Layouts/Header";
import Footer from "./Layouts/Footer";
import HeroSection from "./Pages/HeroSection";
import { FaArrowRight, FaTimes } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import EnquiryImg from "./Assets/Images/EnquireImg.jpg";

const HomePage = () => {
  // const [showCard, setShowCard] = useState(false);
  // const [timerId, setTimerId] = useState(null);
  // const navigate = useNavigate();

  // // Function to open card after given delay
  // const openCard = (delay = 2000) => {
  //   const id = setTimeout(() => {
  //     setShowCard(true);
  //   }, delay);
  //   setTimerId(id);
  // };

  // useEffect(() => {
  //   const sessionClosed = sessionStorage.getItem("enquiryCardClosedForSession");

  //   // If not closed for this session, show after 2 sec
  //   if (!sessionClosed) {
  //     openCard(2000);
  //   }

  //   // Cleanup
  //   return () => {
  //     if (timerId) clearTimeout(timerId);
  //   };
  // }, []);

  // const handleClose = () => {
  //   setShowCard(false);

  //   // Clear existing timer
  //   if (timerId) clearTimeout(timerId);

  //   // Show again after 1 minute
  //   const reopenId = setTimeout(() => {
  //     setShowCard(true);
  //   }, 60000);
  //   setTimerId(reopenId);
  // };

  // const handleCloseForSession = () => {
  //   setShowCard(false);
  //   if (timerId) clearTimeout(timerId);

  //   // Remember this choice for the session
  //   sessionStorage.setItem("enquiryCardClosedForSession", "true");
  // };

  // const handleContactClick = () => {
  //   navigate("/contactUs", { state: { scroll: true } });
  // };

  return (
    <>
      <Header />
      <HeroSection />
      <Footer />

      {/* Floating Enquiry Card */}
      
    </>
  );
};

export default HomePage;
